import React, { FC, memo, useState } from 'react';
import { StoreType } from 'store';
import { selectGroup, selectVisibleGroup } from '../../../../preferencesSelectors';
import { DeploymentTabs } from '../Tabs';
import { GroupContent } from '../GroupContent';
import { ConsentHubGroup } from '../../../../../../services/api';
import { trackTabSwitch } from '../../../../services/userActionEvents';
import { useAppSelector } from '../../../../../../hooks';

export interface OwnProps {
  groupKey: string;
}

const GroupView: FC<OwnProps> = ({ groupKey }) => {
  const [selectedTab, setTab] = useState<string>();
  const group = useAppSelector<StoreType, ConsentHubGroup | undefined>((state) => selectGroup(state, groupKey));
  const visibleGroup = useAppSelector(selectVisibleGroup);

  const switchTab = (tab: string, group: string): void => {
    trackTabSwitch({ tabName: tab, groupName: group });
    setTab(tab);
  };

  if (group == null) return null;

  let tabKeys = Object.keys(group.tabs);

  if (visibleGroup.groupKey !== 'all') {
    tabKeys = tabKeys!.filter((tabKey) => tabKey === visibleGroup.tabKey);
  }

  return (
    <div data-test-group-key={groupKey}>
      <DeploymentTabs tabKeys={tabKeys} onChange={switchTab} groupKey={groupKey} />
      <GroupContent type={group.type} groupKey={groupKey} tabKey={selectedTab ?? tabKeys[0]} />
    </div>
  );
};

export default memo(GroupView);
